import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './VendorLogin.css';
import './VendorRegistration.css';

const FORGOT_PASSWORD_RESOURCES = [
    { type: 'link', rel: 'stylesheet', href: '/assets/vendor/font-awesome/css/fontawesome-all.min.css', id: 'forgot-password-page-fa' },
    { type: 'link', rel: 'preconnect', href: 'https://fonts.googleapis.com', id: 'forgot-password-page-gfont-preconnect1' },
    { type: 'link', rel: 'preconnect', href: 'https://fonts.gstatic.com', crossOrigin: 'true', id: 'forgot-password-page-gfont-preconnect2' },
    { type: 'link', rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap', id: 'forgot-password-page-gfont-style' }
];

// Simple FormMessageDisplay component
const FormMessageDisplay = ({ message, type }) => {
    if (!message) return null;
    const baseStyle = {
        padding: '12px 16px',
        borderRadius: '8px',
        fontSize: '0.9rem',
        fontWeight: '500',
        marginBottom: '20px',
        textAlign: 'left',
        border: '1px solid transparent'
    };
    const styleMap = {
        error: { ...baseStyle, backgroundColor: '#fee2e2', color: '#ef4444', borderColor: '#fca5a5' },
        success: { ...baseStyle, backgroundColor: '#e6f9f3', color: '#0bc184', borderColor: '#a7f3d0' },
        info: { ...baseStyle, backgroundColor: '#eff6ff', color: '#25a5f0', borderColor: '#bfdbfe' }
    };
    const style = styleMap[type] || styleMap.info;
    return (
        <div 
            className="form-message-alert"
            style={style} 
            role="alert" 
            dangerouslySetInnerHTML={{ __html: message }} 
        />
    );
};

function ForgotPassword() {
    // Set page title and inject resources if needed
    useEffect(() => {
        document.title = "Forgot Password";
        FORGOT_PASSWORD_RESOURCES.forEach(attrs => {
            if (!document.getElementById(attrs.id)) {
                const el = document.createElement(attrs.type);
                Object.keys(attrs).forEach(key => { if (key !== 'type') el[key] = attrs[key]; });
                document.head.appendChild(el);
            }
        });
        return () => {
            FORGOT_PASSWORD_RESOURCES.forEach(attrs => {
                const el = document.getElementById(attrs.id);
                if (el) el.remove();
            });
        };
    }, []);

    const [email, setEmail] = useState('');
    const [formMessage, setFormMessage] = useState({ text: '', type: '' });
    const [isLoading, setIsLoading] = useState(false);

    const handlePasswordResetRequest = async (e) => {
        e.preventDefault();
        setFormMessage({ text: '', type: '' });
        if (!email.trim()) {
            setFormMessage({ text: 'Email address is required.', type: 'error' });
            return;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setFormMessage({ text: 'Please enter a valid email address.', type: 'error' });
            return;
        }
        setIsLoading(true);
        try {
            const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/vendors/forgot-password`;
            const response = await axios.post(apiUrl, { email });
            const successMessage = response.data.message || "If an account with that email exists, a password reset link has been sent.";
            setFormMessage({ text: successMessage, type: 'success' });
            setEmail('');
        } catch (err) {
            const errorMessage = err.response?.data?.message || "An error occurred. Please try again later.";
            setFormMessage({ text: errorMessage, type: 'error' });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className="login-page-body">
                <div className="portal-wrapper">
                    <div className="logo-container">
                        <Link to="/">
                            <img src="/logo-mangoloops.png" alt="MangoLoops Logo" />
                        </Link>
                    </div>
                    <div className="auth-card">
                        <div className="header">
                            <h2>Forgot Password</h2>
                            <p>Enter your email address to receive a password reset link.</p>
                        </div>
                        <FormMessageDisplay message={formMessage.text} type={formMessage.type} />
                        <form onSubmit={handlePasswordResetRequest}>
                            <div className="form-group">
                                <label htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    id="email"
                                    placeholder="yourname@example.com"
                                    value={email}
                                    onChange={(e) => {
                                        setFormMessage({ text: '', type: '' });
                                        setEmail(e.target.value);
                                    }}
                                    required
                                    disabled={isLoading}
                                />
                            </div>
                            <button type="submit" className="btn btn-primary-wizard" disabled={isLoading}>
                                {isLoading ? 'Sending...' : 'Send Reset Link'}
                            </button>
                        </form>
                        <div className="footer-switch-text">
                            Remembered your password? <Link to="/login">Sign in</Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ForgotPassword;
